import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DenyRequestsAction = ({ showApprove, disabled }) => (
  <RibbonMenu
    name="deny"
    icon="thumbs down"
    title="actions.deny"
    onClick={showApprove}
    disabled={disabled}
    className="aridhia-deny-action-menu"
    message="actions.deny"
  />
);

export default DenyRequestsAction;
